module.exports = __webpack_public_path__ + "static/media/Lacapital-Studio-Option1-Cam-02-mobile.dc989696.webp";